<template>
    <div>
        <input :id="id" type="radio" :name="name" v-model="localModel" :value="value" @change="e => $emit('updateValue', e.target.value)" />
        <label :for="id">{{ label }}</label>
    </div>
</template>

<script>
import { createUUID } from "@/utils/string";
export default {
    data: () => ({
        id: createUUID(),
        localModel: undefined
    }),
    model: {
        prop: "model",
        event: "updateValue"
    },
    props: {
        label: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        value: {
            required: true
        },
        model: {
            required: true
        }
    },
    created() {
        this.localModel = this.model;
    }
};
</script>

<style scoped lang="scss">
div {
    display: inline-block;
    > * {
        display: inline-block;
        margin-right: 5px;
    }
}
</style>



// WEBPACK FOOTER //
// RadioInput.vue?d03137f0